import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '../../ui/Button/Button';
import { ModalShell } from '../../ui/ModalShell/ModalShell';
import { TranslationKey } from '../../i18n/translationKeys';
import type { TransphereUnsentStepsModalProps } from './types';

const STEP_KEYS = [
    TranslationKey.Home.TransphereUnsentIndicator.StepsModal.Step1,
    TranslationKey.Home.TransphereUnsentIndicator.StepsModal.Step2,
    TranslationKey.Home.TransphereUnsentIndicator.StepsModal.Step3,
];

// Where AcombaGO cannot be asked to open the sending window, the user goes there through Acomba's menus.
export const TransphereUnsentStepsModal: React.FC<TransphereUnsentStepsModalProps> = ({ count, onClose }) => {
    const { t } = useTranslation();
    const closeLabel = t(TranslationKey.Home.TransphereUnsentIndicator.StepsModal.Close);

    return (
        <ModalShell
            heading={t(TranslationKey.Home.TransphereUnsentIndicator.StepsModal.Title)}
            onClose={onClose}
            dismissAriaLabel={closeLabel}
            rootTestId="transphere-unsent-steps-modal"
            titleTestId="transphere-unsent-steps-modal-title"
            dismissTestId="transphere-unsent-steps-modal-dismiss-btn"
            footer={
                <Button variant="secondary" data-testid="transphere-unsent-steps-modal-close-btn" type="button" onClick={onClose}>
                    {closeLabel}
                </Button>
            }
        >
            <div className="flex flex-col gap-l">
                <p data-testid="transphere-unsent-steps-modal-intro" className="text-m text-content">
                    <Trans
                        i18nKey={TranslationKey.Home.TransphereUnsentIndicator.StepsModal.Intro}
                        count={count}
                        values={{ count }}
                        components={{ count: <span className="font-semibold" /> }}
                    />
                </p>
                <ol className="flex flex-col gap-m">
                    {STEP_KEYS.map((key, index) => (
                        <li key={key} data-testid={`transphere-unsent-steps-modal-step-${index + 1}`} className="flex items-center gap-m text-m text-content">
                            <span aria-hidden="true" className="flex size-6 shrink-0 items-center justify-center rounded-full bg-surface-secondary text-xs font-semibold">
                                {index + 1}
                            </span>
                            <span>
                                <Trans i18nKey={key} components={{ menu: <span className="font-semibold" /> }} />
                            </span>
                        </li>
                    ))}
                </ol>
            </div>
        </ModalShell>
    );
};
